// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inputargs.NumberFilterOperation
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let NumberFilterOperation = /*#__PURE__*/function (NumberFilterOperation) {
  NumberFilterOperation[NumberFilterOperation["None"] = 0] = "None";
  NumberFilterOperation[NumberFilterOperation["Equal"] = 1] = "Equal";
  NumberFilterOperation[NumberFilterOperation["GreaterThan"] = 2] = "GreaterThan";
  NumberFilterOperation[NumberFilterOperation["LessThan"] = 3] = "LessThan";
  NumberFilterOperation[NumberFilterOperation["Between"] = 4] = "Between";
  NumberFilterOperation[NumberFilterOperation["Specified"] = 5] = "Specified";
  return NumberFilterOperation;
}({});
(function (_NumberFilterOperation) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? NumberFilterOperation[enumVal] != null ? enumVal : undefined : NumberFilterOperation[enumVal];
  }
  _NumberFilterOperation.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _NumberFilterOperation.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _NumberFilterOperation.indexOf = indexOf;
})(NumberFilterOperation || (NumberFilterOperation = {}));
//# sourceMappingURL=NumberFilterOperation.js.map
